import React, { useState } from "react";
import { parseYouTubeVideoId } from "../lib/youtube";

export function UrlForm({ onSubmit, compact = false, initialValue = "" }) {
  const [value, setValue] = useState(initialValue);
  const [error, setError] = useState("");

  const submit = (event) => {
    event.preventDefault();
    const videoId = parseYouTubeVideoId(value);
    if (!videoId) {
      setError("Paste a valid YouTube link or video ID.");
      return;
    }
    setError("");
    onSubmit(videoId);
  };

  return (
    <form className={`url-form ${compact ? "url-form--compact" : ""}`} onSubmit={submit} noValidate>
      <div className="url-input-wrap">
        <svg viewBox="0 0 24 24" aria-hidden="true"><path d="m10 13 5-3-5-3v6Z" /><rect x="2.5" y="5" width="19" height="14" rx="4" /></svg>
        <input
          type="text"
          value={value}
          onChange={(event) => { setValue(event.target.value); if (error) setError(""); }}
          placeholder="Paste a YouTube URL"
          aria-label="YouTube URL or video ID"
          aria-invalid={Boolean(error)}
          aria-describedby={error ? "url-error" : undefined}
          autoComplete="off"
          spellCheck="false"
        />
      </div>
      <button className="primary-button" type="submit">Shorten video <span aria-hidden="true">→</span></button>
      {error && <p className="field-error" id="url-error" role="alert">{error}</p>}
    </form>
  );
}
